import React, { useState, useEffect } from 'react';
import { createUserWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { Navigate, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { provider } from '../firebase';
import { getAuth, signInWithRedirect } from 'firebase/auth';
import { getRedirectResult, GoogleAuthProvider } from 'firebase/auth';
import { FcGoogle } from 'react-icons/fc';

const auth = getAuth();
getRedirectResult(auth)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access Google APIs.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;

    // The signed-in user info.
    const user = result.user;
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    // ...
  });

const Register = () => {
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const provider = new GoogleAuthProvider();
  const handleLogin = async (e) => {
    try {
      signInWithRedirect(auth, provider);
      navigate('/');
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createUserWithEmailAndPassword(auth, registerEmail, registerPassword);
    } catch (error) {
      alert(error + ' 正しく入力してください');
    }
  };

  const [user, setUser] = useState('');

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, []);

  return (
    <>
      {user ? (
        <Navigate to={`/`} />
      ) : (
        <>
          <h1><a href="../" class="title">のりモコン</a></h1>
          <form onSubmit={handleSubmit}>
            <div>
              <label>メールアドレス</label>
              <br />
              <input
                name="email"
                type="email"
                value={registerEmail}
                onChange={(e) => setRegisterEmail(e.target.value)}
              />
            </div>
            <div>
              <label>パスワード</label>
              <br />
              <input
                name="password"
                type="password"
                value={registerPassword}
                onChange={(e) => setRegisterPassword(e.target.value)}
              />
            </div>
            <button>新規登録</button>
          </form>
        </>
      )}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button onClick={handleLogin} class="google">
        <h2>
          <FcGoogle />{' '}
        </h2>
      </button>
      <p>
        ログインは<Link to={`/login/`}>こちら</Link>
      </p>
    </>
  );
};

export default Register;
